import React from "react";
import { connect, useDispatch } from "react-redux";
import { Button, Tooltip } from "antd";
import { FaSignature } from "react-icons/fa";
import CreateFile from "../../../../upload/CreateFile";
import { initNewLayer } from "../../../Utilities/helper";
import { pick } from "lodash";
import { ARTWORK } from "../../../../../types";
const AddHandWriting = (props) => {
    const { layers } = props;
    const dispatch = useDispatch();

    const addImageHandWriting = (file) => {
        const newImageLayer = initNewLayer();
        newImageLayer.type = "Image";
        newImageLayer.values[0].file = pick(file, ["id", "key"]);
        newImageLayer.imageHandWriting = true;
        newImageLayer.personalized = {
            enable: true
        };
        newImageLayer.title = `Hand Writing #${layers.filter((l) => l.imageHandWriting).length + 1}`;
        dispatch({
            type: ARTWORK.ADD_LAYER,
            payload: newImageLayer,
        });
    }

    return <>
        
        <CreateFile
            accept=".jpg, .png, .jpeg"
            onChange={addImageHandWriting}
        >
            <Tooltip title="Add Hand Writing Layer">
                <Button
                    style={{
                        width: "100%",
                        borderRadius: 0,
                        borderLeftWidth: 0,
                        padding: 0,
                    }}
                    icon={<FaSignature className="anticon" />}
                ></Button>
            </Tooltip>
        </CreateFile>
        
    </>
}

export default connect((state) => ({
  workspace: state.artwork.workspace,
}))(AddHandWriting);